module.exports = __webpack_public_path__ + "static/media/didigiving.0c6d38db.gif";